import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import CryptoJS from "crypto-js";
import { Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useUser } from "./Context/UserContext";
import "../styles/Login.css";
// ── Company Select Popup ──
function CompanySelectPopup({ companies, onSelect, onClose }) {
    const [selectedId, setSelectedId] = useState("");
    const [popupError, setPopupError] = useState("");
    const handleOk = () => {
        alert(selectedId);
        if (!selectedId) {
            setPopupError("Please select a company.");
            return;
        }
        const selected = companies.find(
            c => String(c.id) === String(selectedId)
        );
        onSelect(selected);
    };
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.4)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "20px",
                    width: "300px",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                    fontFamily: "Arial, sans-serif",
                }}
            >
                <h3
                    style={{
                        fontSize: "16px",
                        color: "#333",
                        textAlign: "center",
                        marginBottom: "12px",
                    }}
                >
                    Select Company
                </h3>
                <select
                    value={selectedId}
                    onChange={e => {
                        setSelectedId(e.target.value);
                        setPopupError("");
                    }}
                    style={{
                        width: "100%",
                        height: "40px",
                        marginBottom: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        padding: "0 8px",
                    }}
                >
                    <option value="">-- Select Company --</option>
                    {companies.map(c => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>
                {popupError && (
                    <p
                        style={{
                            color: "red",
                            fontSize: "12px",
                            marginBottom: "8px",
                        }}
                    >
                        {popupError}
                    </p>
                )}
                <button
                    onClick={handleOk}
                    style={{
                        width: "100%",
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#c19a3e",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight: "bold",
                    }}
                >
                    OK
                </button>
                <button
                    onClick={onClose}
                    style={{
                        width: "100%",
                        marginTop: "8px",
                        padding: "10px",
                        backgroundColor: "#ccc",
                        color: "#333",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                    }}
                >
                    Close
                </button>
            </div>
        </div>
    );
}
// ── Login ──
function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showCompanyPopup, setShowCompanyPopup] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [pendingLoginData, setPendingLoginData] = useState(null);
    const { loginUser } = useUser();
    const navigate = useNavigate();
    const INTERNAL_EMAIL = "sathya.raja@mindteck.us";
    const handleCompanySelect = async selectedCompany => {
        try {
            const res = await axios.get(
                `/api/loginrequest/get-vendor-by-id?id=${selectedCompany.id}`
            );
            const vendor = res.data;
            loginUser({
                ...pendingLoginData,
                ID: vendor.id,
                NameOfCompany: vendor.nameOfCompany,
                ContactPersonName: vendor.contactPersonName,
                EmailId: vendor.emailId,
                ContactNumber: vendor.contactNumber,
                Address: vendor.address,
                selectedCompany: {
                    id: vendor.id,
                    name: vendor.nameOfCompany,
                },
            });
            setShowCompanyPopup(false);
            navigate("/master-page", {
                state: { justLoggedIn: true },
            });
        } catch {
            setError("Failed to load company details.");
        }
    };
    const handleLogin = async e => {
        e.preventDefault();
        const hashedPassword = CryptoJS.SHA1(password)
            .toString(CryptoJS.enc.Hex)
            .toUpperCase();
        const loginData = {
            EmailID: email,
            Password: hashedPassword,
        };
        try {
            const response = await axios.post(
                "/api/loginrequest/logins",
                loginData
            );
            const {
                user,
                empId,
                userTypeId,
                userTypeIds,
                roles,
                menus = [],
            } = response.data;
            const actualStatus = user?.status;
            const emailid = user?.emailId;
            const mappedMenus = menus.map(menu => ({
                Id: menu.id || menu.Id,
                MenuName: menu.menuName || menu.MenuName,
                MenuLink: menu.menuLink || menu.MenuLink,
                Parentmenuid:
                    menu.parentmenuid ||
                    menu.Parentmenuid ||
                    null,
            }));
            // ── Security User ──
            if (emailid === "mindteck.security@mindteck.com") {
                if (user && !empId) {
                    loginUser({
                        ...user,
                        empId,
                        userTypeIds,
                        roles,
                        isVendor: false,
                        menus: mappedMenus,
                    });
                    navigate("/master-page", {
                        state: { justLoggedIn: true },
                    });
                } else {
                    setError("Invalid login for security user.");
                }
                // ── Vendor User ──
            } else if (
                actualStatus === "SUCCESS" &&
                Array.isArray(userTypeIds) &&
                userTypeIds.includes(25)
            ) {
                const loginPayload = {
                    ...user,
                    userTypeIds,
                    roles,
                    isVendor: true,
                    menus: mappedMenus,
                };
                if (
                    email.toLowerCase() ===
                    INTERNAL_EMAIL.toLowerCase()
                ) {
                    try {
                        const companyRes = await axios.get(
                            `/api/loginrequest/get-vendor-companies?email=${encodeURIComponent(email)}`
                        );
                        const { companies, password } =
                            companyRes.data;
                        setCompanyList(companies || []);
                        setPendingLoginData({
                            ...loginPayload,
                            overridePassword: password,
                        });
                        setShowCompanyPopup(true);
                    } catch {
                        setError("Failed to load company list.");
                    }
                } else {
                    loginUser(loginPayload);
                    navigate("/master-page", { state: { justLoggedIn: true } });
                }
                // ── Regular / Internal Users ──
            } else if (actualStatus === "SUCCESS") {
                if (user && !empId) {
                    loginUser({
                        user,
                        userTypeId,
                        isVendor: false,
                        menus: mappedMenus,
                    });
                    navigate("/master-page", {
                        state: { justLoggedIn: true },
                    });
                } else if (empId && menus) {
                    loginUser({
                        empId,
                        userTypeIds,
                        roles,
                        isVendor: false,
                        menus: mappedMenus,
                    });
                    navigate("/master-page", {
                        state: { justLoggedIn: true },
                    });
                } else {
                    setError("Missing login details.");
                }
            } else {
                setError("Invalid login status.");
            }
        } catch (error) {
            if (error.response) {
                setError(
                    error.response.data.message || "Login failed."
                );
            } else {
                setError(
                    "Server error. Please try again later."
                );
            }
        }
    };
    return (
        <div className="login-page-wrapper">
            <Link to="/" className="glass-back-to-home">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}>
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Home
            </Link>

            {/* Animated liquid background orbs for the glass effect to shine */}
            <div className="liquid-bg">
                <div className="liquid-orb orb-1"></div>
                <div className="liquid-orb orb-2"></div>
                <div className="liquid-orb orb-3"></div>
            </div>

            <div className="login-glass-card">
                <div className="glass-header">
                    <img 
                        src={require("../assets/Mindteck Logo.png")} 
                        alt="Mindteck Logo" 
                        className="glass-logo-black" 
                    />
                    <h2 className="glass-greeting">Welcome Back!</h2>
                    <h3 className="glass-subheading">Vendor Management System</h3>
                </div>

                <Form onSubmit={handleLogin} className="glass-form">
                    <div className="glass-input-wrapper">
                        <span className="glass-input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                <polyline points="22,6 12,13 2,6"/>
                            </svg>
                        </span>
                        <Form.Control
                            type="text"
                            placeholder="Email address"
                            className="glass-input"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="glass-input-wrapper">
                        <span className="glass-input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                <path d="M7 11V7a5 5 0 0110 0v4"/>
                            </svg>
                        </span>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            className="glass-input"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <Button type="submit" className="glass-btn-liquid">
                        <span>Sign In</span>
                        <svg className="glass-btn-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </Button>
                </Form>

                {error && (
                    <Alert variant="danger" className="glass-error">
                        {error}
                    </Alert>
                )}

                <div className="glass-footer-links">
                    <Link to="/forgot-password" className="glass-link">Forgot Password?</Link>
                    <span className="glass-dot">·</span>
                    <a href="/documents/Usermanual.pdf" download="VMS_User_Manual.pdf" className="glass-link">User manual</a>
                </div>

                <div className="glass-signup-row">
                    Don't have an account? <Link to="/sign-up" className="glass-link-bold">Sign up</Link>
                </div>
            </div>

            {showCompanyPopup && (
                <CompanySelectPopup
                    companies={companyList}
                    onSelect={handleCompanySelect}
                    onClose={() => setShowCompanyPopup(false)}
                />
            )}
        </div>
    );
}
export default Login;